import { connect } from 'react-redux';

import * as CliApp from 'app/entities/CliApp';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import hocify from 'app/common/components/hocify';
import { currentAppEntity } from 'app/developer-v3/selectors';
import { sortVersionStrings } from 'app/developer-v3/utils';

import VersionPicker from './VersionPicker';

const mapStateToProps = state => {
  const appEntity = currentAppEntity(state);
  const versions = CliApp.selectors.versions(appEntity);

  return {
    versions: sortVersionStrings(versions),
    isLoading: CliApp.selectors.all.isLoading(state),
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    async onLoad() {
      return dispatch(CliApp.actions.loadEntity(null, props.integrationId));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(VersionPicker));
